import { billingSubscriptionTransaction } from "../../../../models/axiosModel";
import { thousandSeparator } from "../../../../utils/constants";

const RAZORPAY_INVOICE_BASE_URL = process.env.REACT_APP_RAZORPAY_INVOICE_BASE_URL;

export const getTransactionInvoiceUrl = (transaction: billingSubscriptionTransaction) => {
    const invoiceId = transaction?.transaction_razorpay_invoice_id;
    return invoiceId ? `${RAZORPAY_INVOICE_BASE_URL}/${invoiceId}` : "";
};

export const getTransactionAmount = (transaction: billingSubscriptionTransaction) => {
    const symbol = transaction?.billing_currency_symbol;
    const currency = transaction?.billing_currency_code;
    const numericAmount = Number(transaction?.transaction_amount);
    const amount = Number.isFinite(numericAmount) ? thousandSeparator(numericAmount) : "0";

    return symbol ? `${symbol}${amount}` : currency ? `${currency}${amount}` : `${amount}`;
};
